import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';

import ModalContainer from '../../common/modal-container/modal-container';
import { setPolicyRoute } from '../../../store/slices/generalSlice';
import { RootState } from '../../../store/rootReducer';
import { PolicyStyle } from './policy-style';
import ModalPrivacy from './modal-privacy/ModalPrivacy';
import Modallopd from './modal-lopd/ModalLopd';
import ModalLegal from './modal-legal/ModalLegal';
import ModalCookies from './modal-cookies/ModalCookies';

export type PolicyRouteType = 'cookies' | 'legal' | 'privacy' | 'lopd';

interface IModalPolicy {
  active: boolean;
  route?: PolicyRouteType;
  onClose: () => void;
}

const ModalPolicy: React.FC<IModalPolicy> = ({ active, onClose, route }) => {
  const { policyRoute } = useSelector((state: RootState) => state.general);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPolicyRoute({ policy: route }));
  }, [route, dispatch]);

  const renderContent = () => {
    switch (policyRoute) {
      case 'cookies':
        return <ModalCookies />;
      case 'legal':
        return <ModalLegal />;
      case 'privacy':
        return <ModalPrivacy />;
      case 'lopd':
        return <Modallopd />;
      default:
        break;
    }
  };

  return (
    <ModalContainer fullScreen active={active} onClose={onClose} title="">
      <PolicyStyle>{renderContent()}</PolicyStyle>
    </ModalContainer>
  );
};

export default ModalPolicy;
